import API, { API_URL } from "api/API";
import getForecastDevInfoApi from "api/forecast/getForecastDevInfoApi";
import Dashboard from "components/common/Dashboard";
import DashboardContent from "components/common/DashboardContent";
import DevUpdateStatus from "components/forecast/DevUpdateStatus";
import ErrorLog from "components/forecast/ErrorLog";
import useRunObsDatetime from "libs/hook/useRunObsDatetime";
import { useQuery } from "react-query";
import styled from "styled-components";

const Layout = styled.div`
  display: flex;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  flex: 1;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
`;

const ForecastDev = () => {
  const {data, isLoading} = useQuery({queryKey: [API_URL.FORECAST.GET_DEV_INFO], queryFn: getForecastDevInfoApi})

  useRunObsDatetime();
  
  return <Dashboard title="FORECAST">
    <Layout>
      <div style={{flex: "1"}}>
        <DashboardContent title="OWL Forecast" style={{gridRow: "1 / span 2", flex: "1"}}>
          <iframe src="https://owlnet.kasi.re.kr/forecast" style={{width: "100%", height: "100%"}}></iframe>
        </DashboardContent>
      </div>
      <div style={{width: "700px"}}>
        <DashboardContent title="Update Status" isLoading={isLoading} >
          <DevUpdateStatus data={data?.data?.obs_info} />
        </DashboardContent>
        <DashboardContent title="Error Log" isLoading={isLoading} style={{flex: "1"}} >
          <ErrorLog logs={data?.data?.log} />
        </DashboardContent>
      </div>
    </Layout>
  </Dashboard>
}

export default ForecastDev;